module.exports = __webpack_public_path__ + "img/logo_white.73f67518.png";